import React from 'react';
import { useState } from "react";
import './About.css';
import rippedeffect from "../../assets/images/rippedEffect-white.svg";

import { Button } from "../../components/ui/Button/Button";

const About = () => {
	const [showDetails, setShowDetails] = useState(false);

	const handleButtonClick = () => {
		setShowDetails(!showDetails);
	};
	
	React.useEffect(() => {
		document.documentElement.style.setProperty("--ripped-effect", `url(${rippedeffect})`);
	}, []);
  
  return (
      <section id="about" className="about">
        <h2>À propos</h2>
        <p>
          Passionnée de jeux de société modernes depuis plus de 15 ans, je partage avec enthousiasme cet univers riche et convivial. Mon parcours m’a amenée à vivre des expériences uniques, entre découvertes, rencontres et engagements associatifs, qui nourrissent aujourd’hui mon métier.
        </p>
		
		<div className="button">
			<Button onClick={handleButtonClick}>
				{showDetails ? "Réduire" : "En savoir plus"}
			</Button>
		</div>
		{showDetails && (
			<div className="about-details">
				<p>
					En 2009, une soirée en famille m’a fait découvrir une nouvelle facette des jeux de société. En testant <em>Catan</em> et <em>Smallworld</em>, j’ai compris qu’il existait bien plus que le Monopoly et La Bonne Paye. Ce fut le début d’une toute nouvelle passion pour moi.
				</p>
				<p>
					Au fil des années, cette passion s’est développée, alimentée par des découvertes régulières et des moments de partage. Ma collection a grandi jusqu’à remplir plusieurs bibliothèques, et chaque week-end devenait l’occasion d’explorer de nouveaux horizons : jeux, boutiques, festivals. C’est à cette période que j’ai commencé à m’investir auprès de boutiques de jeux en les assistant tant sur l’organisation de leurs événements que sur la présentation de jeux.
				</p>
				<p>
					Aujourd’hui installée dans l’Ouest Lyonnais, j’ai rejoint l’association <strong>Mines de Jeux</strong>. En tant que secrétaire et bénévole aux multiples casquettes (animatrice, pâtissière, community manager, décoratrice et bien plus 😎), j’y ai retrouvé le plaisir de partager ma passion des jeux de société. Parallèlement, depuis 2023, je suis fière de co-organiser le festival <strong>Les 12 heures du jeu</strong>, un événement qui célèbre le jeu sous toutes ses formes.
				</p>
				<p>
					En créant des animations immersives,  je souhaite transporter chaque joueur dans un univers créé sur mesure où chaque nouveau jeu devient une nouvelle aventure. C’est ce que me procurent les jeux de société, et c’est ce que je veux faire partager.
				</p>
			</div>
		)}
      </section>
  );
};

export default About;